import { SearchInput } from '@/components/SearchInput';
import { useAvatarListPageContext } from '@/pages/avatar/ListPage/contex';

export const Search = () => {
    const { search, setSearch } = useAvatarListPageContext();

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget.value || '';
        setSearch(value);
    };

    const handleSearchClear = () => {
        setSearch('');
    };

    return (
        <SearchInput
            id="avatars-search-textfield"
            placeholder="Search Avatars"
            search={search}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
        />
    );
};
